import { render } from "./IconNorth.vue?vue&type=template&id=80df870e&scoped=true"
const script = {}

import "./IconNorth.vue?vue&type=style&index=0&id=80df870e&lang=scss&scoped=true"

import exportComponent from "/proyectos/programas-de-investigacion/cah-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80df870e"]])

export default __exports__